module.exports = __webpack_public_path__ + "media/images/givvpos-57d83c42838719e69b0ed9cbe3da39f6.png";